import { useEffect, useState } from 'react';
import Header from '../../header/index';
import Footer from '../../footer/index';
import axios from "axios";
import { Modal} from 'bootstrap';
import HeaderSubMenuPage from  './headerSubMenu.js'
import {downloadFile, addBodyClass, getCashiHHeight, setAuthorizationToken} from '../../common/utils';
import SuggestedModal from '../../common/suggestedModal/index';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useAuthenticated, useGetIdentity  } from 'react-admin';
import {refreshTokenGen} from '../../../inMemoryJwt.js';
import '../../../styles.scss';
function HivernagePage() {
    useAuthenticated();
    const [suggestedModalDetail, setMoalDetail] = useState({name:'', id:'', userEmail:''});
    const [pagePost, setPostsData] = useState([]);
    const [projectPost, setProjectData] = useState([]);
    const [activeEdition, setActiveEditon] = useState({index:0, title:'', id:'', state:'',design:false})
    const userIdentity = useGetIdentity();
    const [winHeight, setWinHeight] = useState();
    const [calcHeight, setCalcHeight] = useState();

    const suggestedModal  = (e, name, id) => {
        setMoalDetail({name:name, id:id, userEmail:userIdentity?.data?.email});
        let myModal = new Modal(document.getElementById('suggestedModalCenter'));
        myModal.show();
    }
     useEffect(() => {
            function handleResize() {
                let calcHeight = getCashiHHeight();
                let winHeight = window.innerHeight;
                setWinHeight(winHeight);
                setCalcHeight(calcHeight);
            }
            handleResize();
            addBodyClass();
          
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
    useEffect(() => {
        let getUserId = JSON.parse(localStorage.getItem('userDetails'));
        const tokenExpires = localStorage.getItem('tokenexpires');
        let refreshTOk = localStorage.getItem('refresh_token');
        localStorage.setItem('projectId', undefined);
        if(parseInt(tokenExpires) < new Date().getTime()){
            refreshTokenGen(refreshTOk).then(challenge => {
                if(challenge){
                    getPosts(getUserId?.id);
                }
            })
        } else {
            getPosts(getUserId?.id);
        }
        addBodyClass();
        function handleResize() {
            
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const getPosts = ($userId) => {
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refresh_token');
            axios.get(`${process.env.REACT_APP_API_URL}/hvg-editions/findAllWithProjects/${$userId}`, { headers: setAuthorizationToken(token) })
                .then(response => {
                    if (response.status === 401) {
                        refreshTokenGen(refreshToken).then(challenge => {
                            if(challenge){
                                getPosts($userId);
                            }
                        })
                    } else if(response.data){
                        setPostsData(response.data);
                       const allData =  response.data;
                       const responseLastData = allData?.length - 1;
                       let designVal = allData[responseLastData]?.project?.designs && allData[responseLastData]?.project?.designs.length > 0 ? true :false;
                       let proId = allData[responseLastData]?.project?.id;
                       const activeForum = {index:responseLastData, title:allData[responseLastData]?.fulltitle, id:allData[responseLastData]?.id, state:allData[responseLastData]?.project?.state, proId:proId, design:designVal }
                       setActiveEditon(activeForum);
                    }
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        refreshTokenGen(refreshToken)?.then(challenge => {
                            if(challenge){
                                getPosts($userId);
                            }
                        })
                    }
            });
    }
  
    const activeEditionFun = (e, i, titleTxt, slugTxt, stateTxt, proId, design) => {
        let designVal = design && design.length > 0 ? true :false;
        const activeForum = {index:i, title:titleTxt, id:slugTxt, state:stateTxt, proId:proId, design:designVal}
        localStorage.setItem('activeEdition', titleTxt);
        localStorage.setItem('projectId', proId);
        setActiveEditon(activeForum);
    }
    const elementsPage = (e, id) =>{
        // if(activeEdition.proId){
        //         localStorage.setItem(proId)
        // }
    }
    const youElements = (e, activateId, prodId) => {
        localStorage.setItem('projectId', prodId);
        window.location.href = `/parts-and-service/${activateId}/vos-elements`;
    }
    const gotoPersonnalisationPage = (e, activateId, prodId) => {
        localStorage.setItem('projectId', prodId);
        window.location.href = `/parts-and-service/${activateId}/personnalisation`;
    }
    return (
        <>
        <Header/>
          <div className="breadCrumbSec">
              <div className="container siteContainer">
                    <div className='row'>
                      <div className='col-12'>
                          <ul className="resetList breadCrumbList">
                              <li><span>Parts & Service</span></li>
                          </ul>
                      </div>
                    </div>
              </div>
          </div>
          <div className='farmForumPage'>

            <div className='pageDataSec'>
                <div className='container siteContainer'>
                      <div className='row'>
                          <div className='col-8 leftAlignWidth'>
                          {pagePost.length > 0 &&
                                <HeaderSubMenuPage edtionId= {activeEdition.id} proId={activeEdition.proId} />
                          }
                          </div>
                      </div>
                      <div className='forumPageInner'>
                      <Scrollbars  style={{ height: `calc(${winHeight}px - ${calcHeight}px)`, width: '100%'}}
                renderscrollbarhorizontal={props => <div {...props} className="scrollbar-horizontal" />}
                renderscrollbarvertical={props => <div {...props} className="scrollbar-vertical"/>}
                renderThumbHorizontal={props => <div {...props} className="thumb-horizontal"/>}
                renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
             >
                        <div className='row'>
                          {pagePost.length > 0 &&
                          <>
                            <div className='col-4 sideNavBarCol'>
                                <div className='sideNavBarInner'>
                                    <p className='editionHeading'>éditions</p>
                                        <ul className='resetList editionList'>
                                            { pagePost && pagePost.map((item, index) => (
                                                <li key={index}><button onClick={(e) => activeEditionFun(e, index, item.fulltitle, item.id, item?.project?.state, item?.project?.id, item?.project?.designs )} className={`editionItemTxt ${activeEdition.index === index ? 'active': ''}`}><span className='iconmoon icon-iconright arrowIcon'></span><span className='txt'>{item.fulltitle}</span></button></li>
                                                ))
                                            }
                                        </ul>
                                </div>
                            </div>
                            <div className='col-8 formDetailCol partsServiceCol'>
                                <div className='farmCntInner '>
                                    <div className='formCntList'>
                                        {pagePost.length <= 0 &&
                                            <div className='pageLoading'>
                                            </div>
                                        }
                                        {pagePost.length > 0 &&
                                        <div className='row'>
                                                <div className='col-4 eachFarmItem'>
                                                   <a href={`/parts-and-service/${activeEdition.id}/instructions`} className="eachFarmItemLink">
                                                        <img src="/images/img1.jpg" className='img-fluid' alt=""/>
                                                    </a> 
                                                </div>
                                                <div className='col-4 eachFarmItem'>
                                                    <a onClick={(e) => gotoPersonnalisationPage(e, activeEdition.id, activeEdition.proId)} className={`${activeEdition.proId ? "disbaleBtn" : ""} eachFarmItemLink yourEleMenu`}>
                                                        <img src="/images/img2.jpg" className='img-fluid' alt=""/>
                                                    </a>
                                                </div>
                                                <div className='col-4 eachFarmItem'>
                                                    <a onClick={(e) => youElements(e, activeEdition.id, activeEdition.proId)} className={`${activeEdition.proId ? "" : "disbaleBtn"} eachFarmItemLink yourEleMenu`}>
                                                        <img src="/images/img3.jpg" className='img-fluid' alt=""/>
                                                     </a>
                                                </div>
                                               
                                        </div>
                                    }
                                    </div>
                                </div>
                            </div>    
                            </>
                         }
                             {pagePost.length <= 0 &&
                                <div className='pageLoading'>
                                        <p className='nodataText'>Aucune édition disponible</p>
                                </div>
                            }
                          </div>
                          </Scrollbars >
                      </div>
                    </div>
                </div>

          </div>
        <Footer/>
        </>
    );
  }
export default HivernagePage;
